import { useQuery } from '@tanstack/react-query';

export function useAaroQuery({ queryKey, queryFn, options = {} }) {
    const defaultOptions = {
        refetchOnWindowFocus: false,
        staleTime: 300000, // 5 dakika
        retry: 2,
        ...options,
    };

    return useQuery({
        queryKey: queryKey,
        queryFn: async () => {
            const response = await queryFn();

            if (!response.data?.Sonuc && options.requireSuccess) {
                throw new Error(response.data?.Mesajlar?.Mesaj || 'Veri çekme hatası');
            }
            return response.data?.Model || response.data;
        },
        ...defaultOptions,
    });
}
